import { render, staticRenderFns } from "./DX.vue?vue&type=template&id=78c1f7d0&"
import script from "./DX.vue?vue&type=script&lang=js&"
export * from "./DX.vue?vue&type=script&lang=js&"
import style0 from "./DX.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "DX.vue"
export default component.exports